import { DomeComponent, React } from "@lexriver/dome";
import { EnumIconNames } from "../enums/EnumIconNames";
import css from './ButtonInline.m.scss';


interface Attrs{
    iconName:EnumIconNames
    onClick:(e)=>void
    hoverText?:string
}

export class ButtonInline extends DomeComponent<Attrs>{
    render(){
        return <button title={this.attrs.hoverText} onClick={this.attrs.onClick} class={css.buttonInline}><span class={this.attrs.iconName}/></button>
    }
}